var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoModerateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22040_16214)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.69727 10.3932C1.69727 5.33062 5.80132 1.22656 10.8639 1.22656C15.9265 1.22656 20.0306 5.33062 20.0306 10.3932C20.0306 15.4558 15.9265 19.5599 10.8639 19.5599C5.80132 19.5599 1.69727 15.4558 1.69727 10.3932Z",
    fill: "#FAD271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8623 4.69541C10.7487 4.69369 10.636 4.71466 10.5306 4.75708C10.4253 4.79951 10.3294 4.86254 10.2488 4.94248C10.1681 5.02242 10.1042 5.11767 10.0608 5.22263C10.0174 5.32759 9.99543 5.44016 9.99611 5.55373L10.1563 12.5288C10.1629 12.7107 10.2405 12.8828 10.3724 13.0083C10.5044 13.1337 10.6803 13.2025 10.8623 13.1998C11.0443 13.2024 11.2201 13.1336 11.3521 13.0082C11.484 12.8828 11.5616 12.7107 11.5682 12.5288L11.7285 5.55373C11.7292 5.44016 11.7072 5.32759 11.6638 5.22263C11.6204 5.11767 11.5565 5.02242 11.4758 4.94248C11.3952 4.86254 11.2993 4.79951 11.194 4.75708C11.0886 4.71466 10.9759 4.69369 10.8623 4.69541Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8629 16.4289C11.3848 16.4289 11.8078 16.0059 11.8078 15.484C11.8078 14.9621 11.3848 14.5391 10.8629 14.5391C10.341 14.5391 9.91797 14.9621 9.91797 15.484C9.91797 16.0059 10.341 16.4289 10.8629 16.4289Z",
    fill: "#423E4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22040_16214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.863281 0.390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoModerateIcon);
export default __webpack_public_path__ + "static/media/VOModerateIcon.e8048c51ddf0bc27ab7db735adc2807b.svg";
export { ForwardRef as ReactComponent };